import { DatePipe } from '@angular/common';
import { Component, DestroyRef, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ColDef, GridApi, GridOptions, GridReadyEvent, RowClickedEvent } from 'ag-grid-community';
import { AdminEventService } from './services/admin-event.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AdminEventModel } from '../shared/models/admin-event-models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminEventDetailComponent } from '../admin-event-detail/admin-event-detail.component';
import { DirectionBtnCellRendererComponent } from '../shared/cell-renderers/direction-btn-cell-renderer/direction-btn-cell-renderer.component';
import { faRetweet } from '@fortawesome/free-solid-svg-icons';
import { MsalService } from '@azure/msal-angular';
import { AdminEventImportsComponent } from '../admin-event-imports/admin-event-imports.component';
import { environment } from '../../environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({
    selector: 'app-admin-event',
    templateUrl: './admin-event.component.html',
    styleUrls: ['./admin-event.component.scss'],
    standalone: false
})

export class AdminEventComponent implements OnInit {
  faRetweet = faRetweet;
  rowData: AdminEventModel[];

  private gridApi!: GridApi;

  columnDefs: ColDef[] = [
    {
      headerName: 'Date',
      field: 'date',
      flex: 1,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        const datePipe = new DatePipe('en-US');
        const formattedDate = datePipe.transform(date, 'EEEE MMMM d');
        return formattedDate || '';
      },
      resizable: false
    },
    {
      headerName: 'State Time',
      flex: 1,
      field: 'date',
      valueFormatter: (params) => {
        const date = new Date(params.value);
        const datePipe = new DatePipe('en-US');
        const formattedTime = datePipe.transform(date, 'hh:mm a');
        return formattedTime || '';
      },
      resizable: false
    },
    {
      headerName: 'End Time',
      flex: 1,
      field: 'endDate',
      valueFormatter: (params) => {
        if (params.value !== null) {
          const date = new Date(params.value);
          const datePipe = new DatePipe('en-US');
          const formattedTime = datePipe.transform(date, 'hh:mm a');
          return formattedTime || '';
        } else {
          return '';
        }
      },
      resizable: false
    },
    {
      headerName: 'Event Title',
      field: 'eventTitle',
      flex: 3,
      resizable: false
    },
    {
      headerName: 'Type of Event',
      field: 'eventType',
      flex: 1,
      resizable: false
    },
    {
      headerName: 'Location',
      field: 'location',
      flex: 1,
      resizable: false
    },
    {
      headerName: 'Direction',
      field: '',
      flex: 1,
      cellRenderer: DirectionBtnCellRendererComponent,
      resizable: false
    }
  ];

  gridOptions: GridOptions = {
    columnDefs: this.columnDefs,
    headerHeight: 42,
    rowHeight: 45
  }

  constructor(
    protected http: HttpClient,
    protected router: Router,
    protected service: AdminEventService,
    private destroyRef: DestroyRef,
    private msalService: MsalService,
    private ngbModal: NgbModal,
    private ngZone: NgZone) { }

  ngOnInit(): void {
    this.checkAuthAndLoadEvents();
  }

  private checkAuthAndLoadEvents(): void {
    // TODO: Not sure if this check is actually necessary -WG
    if (typeof sessionStorage === 'undefined') {
      return;
    }

    const account = this.msalService.instance.getActiveAccount();
    if (account != null && environment.Allowed_Users.split(',').includes(account.username)) {
      this.loadEvents();
    }
    else {
      this.login();
    }
  }

  private login(): void {
    this.msalService.handleRedirectObservable()
      .subscribe({
        next: (result) => {
          if (result && result.account) {
            this.msalService.instance.setActiveAccount(result.account);
            this.loadEvents();
            setTimeout(() => {
              this.router.navigateByUrl("/admin-events");
            }, 2000)
          }
          else {
            this.msalService.loginRedirect();
          }
        },
        error: (error) => console.error("Login error:", error)
    });
  }

  private loadEvents(): void {
    this.service.getAllEvents()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(events => {
        this.ngZone.run(() => {
          if (this.gridApi) {
            this.gridApi.setGridOption('rowData', events);
          }
          else {
            this.rowData = events;
          }
        })
      })
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;

    // If data loaded before grid initialized
    if (this.rowData?.length > 0) {
      this.gridApi.setGridOption('rowData', this.rowData);
    }
  }

  rowClicked(event: RowClickedEvent) {
    const detailModal = this.ngbModal.open(AdminEventDetailComponent, { backdrop: false, keyboard: false, size: 'md' });
    detailModal.componentInstance.eventDetail = event.data;
    detailModal.componentInstance.eventDeletedOrEdited
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.checkAuthAndLoadEvents());
  }

  refreshGrid() {
    this.checkAuthAndLoadEvents();
  }

  createNewEvent() {
    const detailModal = this.ngbModal.open(AdminEventDetailComponent, { backdrop: false, keyboard: false, size: 'md' });
    detailModal.componentInstance.eventDeletedOrEdited
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.checkAuthAndLoadEvents());
  }


  importEvents() {
    const importModal = this.ngbModal.open(AdminEventImportsComponent, { backdrop: false, keyboard: false, size: 'xl' });
    importModal.componentInstance.eventsProcessed
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.checkAuthAndLoadEvents());
  }
}
